import { BaseEntity, Validator } from '@core/services/orm/orm';
import { entityClasses } from '@archipad-js/archipad-model';

import BugWorkflowValidator from './validators/BugWorkflowValidator';

export function getEntityClasses(): ReadonlyMap<string, typeof BaseEntity> {
    return new Map<string, typeof BaseEntity>(Object.entries(entityClasses));
}

/** The validators of the ORM context of a project, next to this file. */
export function getValidators(): ReadonlyArray<Validator> {
    return [BugWorkflowValidator];
}
